import { BUXUS_APP_DISPLAY_VERSION } from "../appVersion";
import { resolveWebReleaseStage, type BuxusReleaseStage } from "./releaseStage";

/**
 * Extra properties merged onto every analytics payload from the hybrid web app so reports
 * can segment legacy clients from this web build without changing existing keys on events.
 */
export type AnalyticsSurface =
  | "buxus_web"
  | "buxus_mobile"
  | "legacy_buxusweb"
  | "legacy_buxus_mobile"

export const DEFAULT_WEB_ANALYTICS_CONTEXT = {
  app_surface: "buxus_web" as const,
  app_platform: "web" as const,
}

export function buildWebAnalyticsContext(options?: {
  releaseStage?: BuxusReleaseStage
}): Record<string, unknown> {
  return {
    ...DEFAULT_WEB_ANALYTICS_CONTEXT,
    app_version: BUXUS_APP_DISPLAY_VERSION,
    // Prefer caller-supplied stage (web passes Vite mode fallback); else hostname.
    release_stage: options?.releaseStage ?? resolveWebReleaseStage(),
  }
}

export function mergeAnalyticsContext<T extends Record<string, unknown>>(
  properties: T | undefined,
  context: Record<string, unknown>,
): T & Record<string, unknown> {
  return { ...(properties ?? {}), ...context } as T & Record<string, unknown>
}
